<template>
    <div>
        <vapp-header btnBackToAllInvoices></vapp-header>
        <div class="container-guest">
            <div class="container">
                <router-link to="invoice_details">
                    <div class="alert alert-light-gray">
                        <span style="color: white">Invoice {{ createInvoiceObj.no }}</span>
                        <span class="float-right clearfix" style="color: white">DRAFT</span>
                    </div>
                </router-link>

                <form class="form-fnc" autocomplete="off" @submit.prevent="submitInvoiceDialog">
                    <div class="row section-border">
                        <div class="col">
                            <label for="payment_term">Payment Term</label>
                            <select id="payment_term" class="custom-select padding-override"  @change="changeTerm" v-model="createInvoiceObj.term">
                                <option v-for="term in terms" :value="term" v-bind:key="term.id">{{ term && term.name }}</option>
                            </select>
                            <label for="currency">Currency Info</label>
                            <select id="currency" class="custom-select padding-override"  @change="changeCurrency" v-model="createInvoiceObj.currency">
                                <option disabled>Please select a currency</option>
                                <option v-for="currency in currencies" :value="currency" v-bind:key="currency.id"> {{ currency.code }}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label>Invoice Date</label>
                            <vuejs-datepicker
                                    inputClass="vuejs-datepicker-style-override padding-override"
                                    calendarClass="vuejs-calendar-animation vuejs-calendar-style-override"
                                    v-model="createInvoiceObj.date">
                            </vuejs-datepicker>
                            <label v-if="createInvoiceObj.term && createInvoiceObj.term.name !== 'Cash'">Due Date</label>
                            <vuejs-datepicker v-if="createInvoiceObj.term && createInvoiceObj.term.name !== 'Cash'"
                                    inputClass="vuejs-datepicker-style-override padding-override"
                                    calendarClass="vuejs-calendar-animation vuejs-calendar-style-override"
                                    v-model="createInvoiceObj.due_date">
                            </vuejs-datepicker>
                        </div>
                    </div>

                    <div class="row section-border">
                        <div class="col-3">
                            <div class="add-customer">
                                <router-link :to="{ name: 'select_contact', params: {cat: 'selectedContact'} }">
                                    <img class="img-responsive" src="@/assets/images/ic_add_customer.svg">
                                </router-link>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="add-customer">
                                <router-link to="/select_item">
                                    <img class="img-responsive" src="@/assets/images/ic_add_item.svg">
                                </router-link>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="add-customer">
                                <router-link to="/select_account">
                                    <img class="img-responsive" src="@/assets/images/ic_add_service.svg">
                                </router-link>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="add-customer">
                                <img class="img-responsive" src="@/assets/images/ic_add_payment.svg" @click="navigateSelectPayment">
                            </div>
                        </div>
                    </div>

                    <!-- Customer -->
                    <div class="row section-border" v-if="createInvoiceObj.contact">
                        <div class="col-12">
                            <div >
                                <ul class="customer-list">
                                    <router-link :to="{ name: 'select_contact', params: {cat: 'selectedContact'} }">
                                        <li>
                                            <div class="contact-circle">
                                                <span>{{ createInvoiceObj.contact.display_name.charAt(0) ? createInvoiceObj.contact.display_name.charAt(0) : '' }}</span>
                                            </div>
                                            <span>{{ createInvoiceObj.contact.display_name ? createInvoiceObj.contact.display_name : '' }}</span>
                                        </li>
                                    </router-link>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Items -->
                    <div v-if="createInvoiceObj.items && createInvoiceObj.items.length > 0" class="row section-border invoice-items">
                        <div class="col-12">
                            <div>
                                <ul class="customer-list item-list">
                                    <li v-for="(item, index) in createInvoiceObj.items" :key="index" class="clearfix">
                                        <!--<router-link :to="{ name: 'edit_item', params: { id: item.id } }">-->
                                        <div class="row item-top-row">
                                            <b v-if="item.account_id != null"> {{ item.quantity > 1 ? item.quantity : 1 }} Service</b>
                                            <b v-else> {{ item.quantity > 1 ? item.quantity : 1 }} Item</b>

                                            <img @click="removeItem(index)" src="@/assets/images/ic_delete.svg">
                                        </div>
                                        <div class="row" v-on:click.native="goToItem">
                                            <div class="col">
                                                <span>{{ item.display_name }} </span>
                                            </div>
                                            <div class="col">
                                                <span class="item-list float-right">{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol }} {{ $numberWithCommas(item.unit_price * (item.quantity > 1 ? item.quantity : 1)) }}</span>
                                            </div>
                                        </div>
                                        <div class="row item-mid-row">
                                            <div class="col-1">
                                                <p><span>{{ item.quantity > 1 ? item.quantity : 1 }}</span></p>
                                            </div>
                                            <div class="col-3">
                                                <input type="number" id="unit_price" class="form-control padding-override inp-unit-price" v-model="item.unit_price">
                                            </div>
                                            <div class="col-1 custom-col">
                                                <img class="img-discount" src="@/assets/images/ic_discount.svg">
                                            </div>
                                            <div class="col-3">
                                                <input type="text" id="discount" class="form-control padding-override inp-discount" v-model="item.discount">
                                            </div>
                                            <div class="col-4 custom-col">
                                                <div class="col-quantity">
                                                    <img class="img-minus" src="@/assets/images/ic_minus.svg" @click="changeQuantityDecrement(index, item.quantity)">
                                                    <input readonly type="text" id="quantity" class="form-control padding-override inp-quantity" v-model="item.quantity">
                                                    <img class="img-plus" src="@/assets/images/ic_plus.svg" @click="changeQuantityIncrement(index, item.quantity)">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row" v-if="item.sale_tax_code_id != null">
                                            <div class="col-4">
                                                <span>Tax Code : {{ item.sale_tax_code}}</span>
                                            </div>
                                        </div>
                                        <!--<div class="row">-->
                                            <!--<div class="col-6" v-if="taxCodes.length > 99 ">-->
                                                <!--<label for="tax_code">Tax Code</label>-->
                                                <!--<select id="tax_code  class="custom-select padding-override" @change="setTaxItems(index, taxCode)" v-model="taxCode">-->
                                                    <!--<option selected> No Tax Code</option>-->
                                                    <!--<option v-for="taxCode in taxCodes" :value="taxCode" >{{ taxCode.code }}</option>-->
                                                <!--</select>-->
                                            <!--</div>-->

                                        <!--</div>-->
                                        <div class="col-12" v-if="item.account_id">
                                            <div class="notes">
                                                <span>Name & Description</span>
                                                <textarea class="form-control" cols="30" rows="5" placeholder="Name & Description" v-model="item.name"></textarea>
                                            </div>
                                        </div>
                                        <!--</router-link>-->
                                        <div v-if="index !== createInvoiceObj.items.length - 1" class="row section-border" style="margin-bottom:20px"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Payment -->
                    <div  class="row section-border" v-if="createInvoiceObj.partials && createInvoiceObj.partials.length > 0">
                        <div class="col-12">
                            <div>
                                <ul class="customer-list item-list">
                                    <li v-for="(payment, index) in createInvoiceObj.partials" v-bind:key="payment.id"  class="clearfix">
                                        <div class="row" style="padding-left: 15px; margin-top: -10px; padding-bottom:5px">
                                            <b>1 Payment</b>
                                            <img  @click="removePayment(index)"  style="position: absolute;right: 0;margin-right: 10px" src="@/assets/images/ic_delete.svg">
                                        </div>
                                       <div class="row">
                                            <div class="col-6" v-if="payment.method_id">
                                                <span>{{ payment.method_name}}</span>
                                            </div>
                                            <div class="col-6" v-if="payment.method_id">
                                                <span style="position: absolute;right: 0;margin-right: 10px"><b>{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol }} {{ $numberWithCommas(payment.amount) }}</b></span>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom:8px">
                                            <div class="col-6" v-if="payment.method_id">
                                                <span>{{ payment.account_name}}</span>
                                            </div>
                                        </div>
                                        <div v-if="index !== createInvoiceObj.partials.length - 1" class="row section-border" style="margin-bottom:20px"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="notes">
                                <span>Notes</span>
                                <textarea class="form-control" id="" cols="30" rows="5" placeholder="Additional notes to your customer" v-model="createInvoiceObj.memo" @change="setInvoiceMemo"></textarea>
                            </div>           
                        </div>
                    </div>  
                </form>
                
                <div class="invoice-buttons row">
                    <div class="col-6">
                        <div class="row">
                            <b style="padding-bottom: 7px">GRAND TOTAL</b>                        
                        </div>
                        <div class="row">
                            <span style="font-size: x-large;">{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol }} {{ $numberWithCommas( grandTotal) }}</span>
                            <img @click="showDialog = true" style="width: 10%;transform: rotate(180deg);margin-left: 15px;margin-top: -10px" src="@/assets/images/sh-icon-arrow-down.svg">
                        </div>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-block btn-fnc" @click="submitInvoiceDialog">Save</button>
                    </div>    
                </div>
            </div>
        </div>

        <md-dialog :md-active.sync="showDialog">
            <div class="col-12">
                <div class="subtotal">
                    <span>Subtotal</span>
                    <span class="float-right">{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol }} {{ $numberWithCommas(subTotal) }}</span>
                </div>
                <div class="subtotal">
                    <span>Grand Total</span>
                    <span class="float-right">{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol }} {{ $numberWithCommas(grandTotal) }}</span>
                </div>
                <div class="subtotal">
                    <span>Balance</span>
                    <span class="float-right">{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol}} {{ $numberWithCommas(balance) }}</span>
                </div>
                <div class="subtotal"  v-if="grandTotal - subTotal < 0">
                    <span>Discount</span>
                    <span class="float-right">{{ createInvoiceObj.currency && createInvoiceObj.currency.symbol }} {{ $numberWithCommas(grandTotal - subTotal) }}</span>
                </div>                
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="showDialog = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import * as $$ from "lodash";
    import listSvc from '../../services/listService'
    import invoiceSvc from '../../services/invoiceService'
    import currencySvc from  '../../services/currencyService'

    export default {
        name: "CreateInvoice",
        data: function() {
            return {
                showDialog: false,
                terms:[],
                taxCodes: [],
                taxCode: {},
                baseCurrency: {},
                currencies: [],
            };
        },
        computed: {
            ...mapState('invoice', ['createInvoiceObj', 'paymentAmount']),
            ...mapState('company', ['selectedCompany']),
            paymentTotal : function() {
                let paymentTotal = 0;
                $$.each(this.payments, function(payment) {
                    paymentTotal += parseFloat(payment.amount)
                });
                return paymentTotal;
            },
            subTotal: function() {
                let subTotal = 0;
                $$.each(this.createInvoiceObj.items, (item) => {
                    subTotal += item.unit_price * item.quantity;
                });
                return subTotal
            },
            grandTotal: function() {
                let grandTotal = 0;
                $$.each(this.createInvoiceObj.items, (item) => {
                    var currentTotal = item.unit_price * item.quantity;
                    if (item.discount !== undefined) {
                        var discountFormat = item.discount;
                        if (discountFormat.includes('%')) {
                            var discount = discountFormat.slice(0, -1);
                            currentTotal = currentTotal - (currentTotal * (discount/100))
                        } else {
                            currentTotal = currentTotal - (currentTotal * (item.discount/100))
                        }
                    }
                    grandTotal += currentTotal; 
                });
                return grandTotal;
            },
            balance: function() {
                let balance = 0;
                let totalPayment = 0;
                 $$.each(this.createInvoiceObj.partials, (partial) => {
                    totalPayment += partial.amount;
                });
                balance = totalPayment - this.grandTotal;
                this.setPaymentAmount(Math.abs(balance));
                return balance;
            },
        },
        methods: {
            ...mapActions('invoice',['setCreateInvoiceObj', 'removeItem', 'setCurrentPaymentLine', 'removePayment', 'changeItemDescription', 'changeItemDiscount', 'changeItemUnitPrice', 'setPaymentAmount', 'changeItemQuantity']),
            navigateSelectPayment () {
                if (this.createInvoiceObj.partials === undefined) {
                    this.setCurrentPaymentLine(1);
                } else {
                    this.setCurrentPaymentLine(this.createInvoiceObj.partials.length + 1);
                }
                this.$router.push('/select_payment')
            },
            changeCurrency(){       
                console.log("change Currency");         
                let config = {
                    params : {
                        company_id : this.selectedCompany,
                        from_currency_id: this.createInvoiceObj.currency.id,
                        to_currency_id: this.baseCurrency.id,
                        date: new Date()
                    }
                };

                currencySvc.methods.getCurrencyRate(config)
                    .then(response => {
                        this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                            currency_rate: response.rate.rate,
                        });
                    });
            },
            setItemsDescription(itemIndex, description){
                let data = {
                    index: itemIndex,
                    name: description
                };
                this.changeItemDescription(data);
            },
            setItemDiscount(itemIndex, discount) {
                let data = {
                    index: itemIndex,
                    discount: discount
                };
                this.changeItemDiscount(data);
            },
            setItemUnitPrice(itemIndex, unitPrice) {
                let data = {
                    index: itemIndex,
                    sale_price: unitPrice ? parseFloat(unitPrice) : 0
                };
                this.changeItemUnitPrice(data);
            },
            setTaxItems(index, taxCode){
            },
            changeQuantityIncrement(itemIndex, quantity){
                let data = {
                    index: itemIndex,
                    quantity: quantity + 1,
                };
                this.changeItemQuantity(data);
            },
            changeQuantityDecrement(itemIndex, quantity) {
                let data = {
                    index: itemIndex,
                    quantity: quantity - 1,
                };
                this.changeItemQuantity(data);
            },
            submitInvoiceDialog() {
                this.$confirmationToast("Create Invoice?", "Are you sure you want to create this invoice?", this.submitInvoice, null);
            },
            submitInvoice() {
                var newInvoiceFromStore = this.createInvoiceObj;
                let formatedPartial = [];
                let formatedItem = [];

                $$.each(newInvoiceFromStore.partials, (partial) => {
                    formatedPartial.push({
                        method_id: partial.method_id,
                        account_id: partial.account_id,
                        amount: partial.amount
                    })
                });

                $$.each(newInvoiceFromStore.items, (item, index) => {
                    formatedItem.push({
                        name: item.name,
                        line: item.line,
                        quantity: item.quantity,
                        unit_price: item.unit_price,
                    })
                    if (item.product_id) {
                        formatedItem[index].product_id = item.product_id;
                    }
                    if (item.account_id){
                        formatedItem[index].account_id = item.account_id;
                    }
                });

                var newInvoiceToPost = {
                    contact_id : newInvoiceFromStore.contact.id,
                    currency_id: newInvoiceFromStore.currency.id,
                    currency_rate : newInvoiceFromStore.currency_rate,
                    date: newInvoiceFromStore.date,
                    business_id: this.selectedCompany,
                    files: [],
                    is_cash_term: newInvoiceFromStore.is_cash_term ,
                    items: formatedItem,
                    memo: newInvoiceFromStore.memo,
                    no: newInvoiceFromStore.no,
                    status: 0,
                    tags: [],
                    tax_inclusive: false,
                    term_id : newInvoiceFromStore.term.id
                }
                if (newInvoiceToPost.is_cash_term) {
                    newInvoiceToPost.partials = formatedPartial;
                }

                invoiceSvc.methods.postInvoice(newInvoiceToPost);
            },
            changeTerm (){
                console.log("change Term");
                let isCashTerm = false;

                this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                    term : this.createInvoiceObj.term,
                });
                this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                    due_date:  this.$moment().add(this.createInvoiceObj.term.day, 'days').format("YYYY-MM-DD")
                });

                if (this.createInvoiceObj.term.name === 'Cash') {
                    isCashTerm = true;
                }
                this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                    is_cash_term: isCashTerm
                });
            },
            setInvoiceMemo() {
                this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                    memo:  this.createInvoiceObj.memo
                });
            },
            setInvoiceDefaultData(){
                this.createInvoiceObj.is_cash_term = false;

                $$.each(this.terms, (term) => {
                    if (term.name === 'Cash') {    
                        this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                            date: this.$moment().format("YYYY-MM-DD"),
                            term: term,
                            is_cash_term : true
                        });
                        this.changeTerm();
                    }
                });

                $$.each(this.currencies, (currency) => {
                    if (currency.is_primary){
                        this.baseCurrency = currency;
                        this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                            currency: currency
                        });
                        this.changeCurrency();
                    }
                });
            }
        },
        mounted() {
            console.log("Mounted : Create Invoice");
            invoiceSvc.methods.getNextNo(this.selectedCompany);
            let data = {
                "requests":[
                    {
                        "uri" : "/lists/terms",
                        "params": {
                            "company_id": this.selectedCompany
                        }
                    },
                    {
                        "uri" : "/lists/tax_codes",
                        "params": {
                            "company_id": this.selectedCompany,
                            "is_sale_tax": true,
                            "date" : Date.now()
                        }
                    },
                    {
                        "uri" : "/lists/currencies",
                        "params": {
                            "company_id":this.selectedCompany
                        }
                    },
                ]
            };

            listSvc.methods.readMixed(data).then(data => {
                this.terms = data.terms;
                this.taxCodes = data.tax_codes;
                this.currencies = data.currencies;
                // this.setInvoiceDefaultData();
                if (!this.createInvoiceObj.term) {
                    this.setInvoiceDefaultData();
                }
            });
        }
    };
</script>

<style scoped lang="scss">
    .invoice-items {
        .item-top-row {
            padding-left: 15px; 
            margin-top: -10px; 
            padding-bottom:5px;
            img {
                position: absolute;right: 0;margin-right: 10px
            }
        }
        .item-mid-row {
            .custom-col {
                padding-left:0px; 
                padding-right:0px;
                
                .col-quantity {
                    position: absolute;
                    right: 0;
                    margin-right: 10px;

                    .img-minus {
                        width:15px; 
                        margin-right: 10px;
                    }

                    .img-plus {
                        width:15px; 
                        margin-left: 10px;
                    }
                }
            }
            .inp-unit-price {
                border-radius: 5px !important; 
                height: 35px; 
                font-size: smaller;
            }
            .img-discount {
                width:25px; 
                display:block;
                display: block;
                margin-right: auto;
                margin-left: auto;
            }
            .inp-discount {
                border-radius: 5px !important; 
                height: 35px;
            }
            .inp-quantity {
                border-radius: 5px !important; 
                height: 35px; width:40px; 
                display:-webkit-inline-box
            }
        }
    }
    .md-dialog {
        height: 250px;
        width: 100px;
        margin-bottom: 30%;
    }

    /* Invoice Title */
    .alert {
        margin: 15px 0 15px 0;
    }

    .section-border {
        border-bottom: 10px solid rgba(68, 43, 43, 0.1);
    }

    input,
    select {
        margin-bottom: 15px;
    }

    .payment-date-dialog {
        background-color: white;
        top: 50%;
        transform: translateY(-50%);
        max-width: 768px;
        border-radius: 3px;
        padding: 5px;
        margin: 5px;
        height: 185px;

        .md-field {
            width: calc(100% - 50px) !important;
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }

    /* Add Customer Button */
    .add-customer {
        cursor: pointer;

        a {
            text-decoration: none;
        }

        img {
            width: 40px;
            display: block;
            margin-left: auto;
            margin-right: auto;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        span {
            font-weight: 500;
            color: #05d2c5;
        }
    }

    .customer-list {
        padding-left: 0;
        margin-bottom: 0;

        a {
            text-decoration: none;
            color: inherit;
            li {
                .contact-circle {
                    background: #24cab7;
                    border-radius: 50%;
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    margin-right: 15px;
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    text-align: center;

                    span {
                        color: white;
                        text-transform: lowercase;
                        line-height: 43px;
                        font-size: 1.25rem;
                    }
                }
            }
            span {
                transition: all 0.3s ease-in-out;
            }
        }

        li {
            cursor: pointer;
            list-style: none;
            padding: 0 0 15px 0;
            transition: all 0.3 ease-in-out;

            img {
                width: 15px;
            }
        }
    }

    .item-list {
        li {
            padding-bottom: 0;
        }

        p {
            margin-top: 7px;
            span {
                color: #8aa2b2;
            }

            span:nth-of-type(1) {
                background-color: #8aa2b2;
                border-radius: 4px;
                color: white;
                font-weight: 600;
                padding: 1px 5px;
            }
        }
    }

    .item-list.float-right {
        font-weight: 500;
    }

    /* Subtotal / Divider / Due  */
    .subtotal {
        padding: 20px 0;
    }

    .divider {
        height: 1px;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .notes {
        textarea {
            margin-top: 10px;
            margin-bottom: 75px;
            border-color: #05d2c5;
            border-radius: 10px;
            padding: 15px;
        }
    }
    .md-card {
    width: 320px;
    margin: 4px;
    
    vertical-align: top;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

    .due {
        padding: 20px 0 20px 15px;
        background-color: #e4f5fc;
        margin-bottom: 15px;

        .custom-select {
            width: 125px;
            margin-bottom: 0;
            background-color: transparent;
            border: none;
            padding-left: 0;
        }

        span {
            margin-top: 10px;
            margin-right: 15px;
        }

        span:nth-of-type(2) {
            font-weight: 500;
        }

        img {
            width: 12px;
        }
    }

    .selected {
        border-radius: 3px;
    }

    .invoice-buttons {
        position: fixed;
        bottom: 0;
        min-width: 100%;
        padding-left: 25px;
        padding-right: 25px;
        right: 0;
        left: 0;
        padding-top: 15px;
        padding-bottom: 15px;
        background-color: #e4f5fc;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        z-index: 10;

        .btn {
            text-transform: uppercase;
        }

        .btn-fnc-override {
            background-image: none;
            background-color: white;
            border: 1px solid #6b7377;
            color: #6b7377;
        }
    }

    .checkAppear {
        margin-right: 10px;
    }

    .slideInRight {
        animation: slideInRight 0.3s ease-in-out;
        animation-fill-mode: forwards;
    }

    .slideOutLeft {
        animation: slideOutLeft 0.3s ease-in-out;
        animation-fill-mode: forwards;
    }

    @keyframes slideInRight {
        0% {
            transform: translateX(-25px);
            opacity: 0;
        }

        100% {
            transform: translateX(0px);
            opacity: 1;
        }
    }

    @keyframes slideOutLeft {
        0% {
            transform: translateX(0px);
            opacity: 1;
        }

        100% {
            transform: translateX(-25px);
            opacity: 0;
        }
    }

    .img-responsive {
        
    }
    .form-control:disabled, .form-control[readonly] {
    background-color: white;
    opacity: 1;
}
</style>
